import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';
import utilService from '../../../../services/UtilService';

import styles from './MultimediaDisplay.scss';

let iconFadeHandle = null;
let mouseMoveLastRegistered = null;
let mouseMoveSessionHandle = null;

class VideoControlsOverlay extends React.Component {
    static propTypes = {
        action: PropTypes.string,
        fullyLoaded: PropTypes.bool,
        onClick: PropTypes.func,
        playing: PropTypes.bool,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            hideOverlayIcon: false,
        };
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.playing && this.props.playing) {
            this.setState({ hideOverlayIcon: false });
            this.cancelFade();
        }
    }

    startMouseMoveSession = () => {
        mouseMoveLastRegistered = utilService.getCurrentTimeStamp();
        mouseMoveSessionHandle = setInterval(this.onMouseMoveInterval, 100);
    };

    cancelMouseMoveSession = () => {
        clearInterval(mouseMoveSessionHandle);
        mouseMoveSessionHandle = null;

        if (iconFadeHandle === null) {
            iconFadeHandle = setTimeout(() => {
                if (this.props.playing) {
                    this.setState({ hideOverlayIcon: true });
                }
                iconFadeHandle = null;
            }, 500);
        } else {
            this.cancelFade();
        }
    };

    cancelFade = () => {
        clearTimeout(iconFadeHandle);
        iconFadeHandle = null;
    };

    onMouseMoveInterval = () => {
        if (utilService.getCurrentTimeStamp() - mouseMoveLastRegistered > 100) {
            this.cancelMouseMoveSession();
        }
    };

    onUserActivity = (ignorePlayingStatus = false) => {
        if (!this.props.playing && !ignorePlayingStatus) {
            return;
        }

        if (this.state.hideOverlayIcon === true) {
            this.setState({ hideOverlayIcon: false });
        }

        if (mouseMoveSessionHandle === null) {
            this.startMouseMoveSession();
            return;
        }

        mouseMoveLastRegistered = utilService.getCurrentTimeStamp();
    };

    onClick = () => {
        if (this.props.action === 'play') {
            this.onUserActivity(true);
        }
        this.props.onClick();
    };

    render() {
        const btnProps = {
            icon: 'fa fa-lock',
            className: ['playerButton'],
            title: t('multimedia.actionButton.locked'),
        };

        if (this.props.action === 'play') {
            btnProps.icon = 'fa fa-play-circle';
            btnProps.title = t('multimedia.actionButton.play');
        } else if (this.props.action === 'pause') {
            btnProps.icon = 'fa fa-pause';
            btnProps.title = t('multimedia.actionButton.pause');
        } else if (!this.props.fullyLoaded) {
            btnProps.icon = 'fa fa-play-circle';
            btnProps.title = t('multimedia.actionButton.play');
        }

        const buttonClassNames = ['overlayIcon'];
        if (this.props.playing && this.props.action === undefined) {
            buttonClassNames.push('hide');
        } else if (this.state.hideOverlayIcon) {
            buttonClassNames.push('fadeOut');
        }

        return (
            <button
                className={styles.controlsOverlay}
                disabled={this.props.onClick === undefined}
                onMouseMove={this.onUserActivity}
                onClick={this.onClick}
            >
                <span className={buttonClassNames.join(' ')} >
                    <i className={btnProps.icon} />
                </span>
            </button>
        );
    }
}

export default VideoControlsOverlay;
